export enum PlanType {Free, Trial, Premium}
export enum PlanStatus {Active = 0, Canceled = 1, Expired = 2}
export enum UserStatus {Active, Suspended}

export interface Subscription {
  customerId: string,
  subscriptionId: string
}


export interface Plan {
  type: PlanType,
  status: PlanStatus,
  startDate: Date,
  endDate: Date,
  daysLeft: number,
  subscription: Subscription,
}

export interface User {
  id: string,
  idPId: string,
  email: string,
  plan: Plan,
  status: UserStatus,
  createdAt: Date,
  updateddAt: Date,
  isAdmin?: boolean,
}

export interface AdminUser {
  id: string;
  email: string;
  planType: PlanType;
  planStatus: PlanStatus;
  planStartDate: string;
  activeRoomsCount: number;
  lastSignInAt: string;
  createdAt: string;
}

export interface PaginatedUsersResponse {
  users: AdminUser[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface UserDetailsResponse {
  id: string;
  email: string;
  planType: PlanType;
  planStatus: PlanStatus;
  planStartDate: string;
  lastSignInAt: string;
  createdAt: string;
  activeRooms: ActiveRoomInfo[];
}

export interface ActiveRoomInfo {
  roomId: string;
  urlId: string;
  state: string;
  playerName: string;
  isModerator: boolean;
  isObserver: boolean;
  lastSeenAt: string;
  roomCreatedAt: string;
  roomUpdatedAt: string;
  totalPlayers: number;
  estimationRounds: number;
}